import { Link } from "react-router-dom";

export default function PageHead({ crumb, eyebrow, title, lede }) {
  return (
    <header className="page-head">
      <div className="container">
        <div className="page-head__grid">
          <div className="reveal">
            <div className="crumb">
              <Link to="/">Docket</Link> / {crumb}
            </div>
            <div className="eyebrow">{eyebrow}</div>
            <h1>{title}</h1>
          </div>
          <p className="page-head__lede reveal d1">{lede}</p>
        </div>
      </div>
    </header>
  );
}
